import { render, staticRenderFns } from "./SectionIcon.vue?vue&type=template&id=3537e852"
import script from "./SectionIcon.vue?vue&type=script&lang=js"
export * from "./SectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports